import isEmpty from 'lodash.isempty';
import get from 'lodash.get';
import { INTERP_COLOR_MAPPER } from '../../constants/shared/CommonInterpretationMapper';

export const getCutscoresObjectFromThresholds = (thresholds, colorMapper = INTERP_COLOR_MAPPER) => {
    const cutscores = {};
    Object.keys(colorMapper).forEach(interp => {
        const interpObject = thresholds.find(threshold => threshold.interp === interp);
        if (!isEmpty(interpObject)) cutscores[interpObject.interp] = interpObject.scoreThreshold;
    });
    return cutscores;
};

export const getThresholdsByMeasureGradePeriod = (interps, measure, grade, period) => {
    const interpObject = interps.find(
        interp => interp.measure === measure && interp.grade === grade && interp.period === period,
    );
    return get(interpObject, 'thresholds', []);
};

export const getInterpsDataExcludingR3D = (interpsData, measure) =>
    isEmpty(interpsData) ? interpsData : interpsData.filter(interp => measure !== interp.measure);

export const getDyslexiaInterpBoundaries = interpData => ({
    maxScore: interpData.max_score,
});
